import React from "react";
import "./styles.css"

const Button = ({ id, form, text, type, disabled, onClick }) => {
	const handleMouseDown = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<button
				id={id}
				form={form}
				className={"cybrBtn"}
				type={type}
				disabled={disabled}
				onClick={onClick}
				onMouseDown={handleMouseDown}
			>
				{text}
			</button>
		</>
	);
};

export default Button;
